module.exports = __webpack_public_path__ + "img/logo_big.c41002a5.svg";